import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AdminType } from '../enums/admin-type.enum';
import { AdminService } from '../services/admin.service';
import { QueryAdminsDto } from '../dtos/query-admins.dto';
import { AdminDto } from '../dtos/admin.dto';
import { ErrorService } from '../../../core/services/error.service';
import { AdminTypePipe } from '../pipes/admin-type.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { AddAdminDialog } from '../dialogs/add-admin/add-admin.dialog';
import { AdminTypeTitlePipe } from '../pipes/admin-types-title.pipe';
import { EditAdminDialog } from '../dialogs/edit-admin/edit-admin.dialog';
import { StorageService } from '../../../core/services/storage.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MatMenuModule } from '@angular/material/menu';
import { LocationSummaryDto } from '../../location/dtos/location-summary.dto';
import { LocationService } from '../../location/services/location.service';
import { environment } from '../../../../environments/environment';
import { MemoryService } from '../../../core/services/memory.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-components',
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatCardModule,
    AdminTypePipe,
    ReactiveFormsModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    AdminTypeTitlePipe,
    TranslocoPipe,
    MatMenuModule
  ],
  templateUrl: './admins.component.html',
  styleUrl: './admins.component.scss'
})
//todo remove comment
export class AdminsComponent implements OnInit {
  @ViewChild('table') table!: MatTable<any>;

  adminTypeSelector!: FormControl;
  adminDtos!: AdminDto[];
  locationSummaryDtos!: LocationSummaryDto[];

  loggedInAdminEmail: string | null = null;

  constructor(private adminService: AdminService, private translocoService: TranslocoService, private errorService: ErrorService, private dialog: MatDialog, private storageService: StorageService, private locationService: LocationService, private memoryService: MemoryService, private snackBar: MatSnackBar) {
  }

  get adminTypes() {
    return Object.values(AdminType);
  }

  ngOnInit() {
    this.loggedInAdminEmail = this.storageService.loadEmail();
    this.adminTypeSelector = new FormControl(AdminType.admin);

    this.locationService.getLocationSummaries().subscribe({
      next: (locationSummaryDtos: LocationSummaryDto[]) => {
        this.locationSummaryDtos = locationSummaryDtos;
      },
      error: (error) => this.errorService.handleError(error, this.translocoService.translate("error.title.locations"))
    });

    this.queryAdmins(AdminType.admin);
  }

  queryAdmins(adminType: AdminType): void {
    console.log(adminType);
    let queryAdminsDto: QueryAdminsDto = { adminType: adminType };
    this.adminService.queryAdmins(queryAdminsDto).subscribe({
      next: (adminDtos: AdminDto[]) => {
        this.adminDtos = adminDtos;
        // this.table.renderRows();
      },
      error: (error) => this.errorService.handleError(error, this.translocoService.translate("error.title.admins"))
    });
  }

  changeAdminType(event: any): void {
    let adminType: AdminType = event;
    this.queryAdmins(adminType);
  }

  addAdmin(): void {
    let adminType: AdminType = this.adminTypeSelector.value;

    this.dialog.open(AddAdminDialog, { autoFocus: false, data: { defaultAdminType: adminType } })
      .afterClosed()
      .subscribe((reload) => {
        if (reload) {
          this.queryAdmins(this.adminTypeSelector.value);
        }
      });
  }

  editAdmin(adminDto: AdminDto): void {
    this.dialog.open(EditAdminDialog, { autoFocus: false, data: { adminDto: adminDto } })
      .afterClosed()
      .subscribe((reload) => {
        if (reload) {
          this.queryAdmins(this.adminTypeSelector.value);
        }
      });
  }

  locationName(locationId: number): string {
    if (locationId == 0) {
      return this.translocoService.translate('label.location.all');
    }

    let locationSummaryDto = this.locationSummaryDtos.find((locationPreviewDto) => locationPreviewDto.locationId == locationId);
    return `${locationSummaryDto?.name} - ${locationSummaryDto?.city}, ${locationSummaryDto?.street}`;
  }

  copyUrl(locationId: number) {
    const url = `${environment.cenplexBookingWebUrl}/appointment-selection?customerId=${this.memoryService.customerId}&locationId=${locationId}&ismanager=1`;

    navigator.clipboard.writeText(url).then(() => {
      this.snackBar.open(this.translocoService.translate('label.snackbar'), 'OK', {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom'
      });
    });
  }
}
